var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.5816 4 4 7.5816 4 12C4 16.4184 7.5816 20 12 20C16.4184 20 20 16.4184 20 12L18.4 12C18.3999 13.505 17.8694 14.9618 16.9017 16.1145C15.9341 17.2671 14.5912 18.0419 13.1089 18.3027C11.6267 18.5635 10.1 18.2935 8.79704 17.5404C7.49408 16.7872 6.49824 15.5989 5.98447 14.1843C5.4707 12.7697 5.47188 11.2193 5.9878 9.80553C6.50372 8.39174 7.50138 7.20498 8.80549 6.45377C10.1096 5.70257 11.6367 5.43497 13.1185 5.698C14.6004 5.96103 15.9421 6.73786 16.908 7.892L15.2 9.6L20 9.6L20 4.8L18.0424 6.7568C17.2921 5.89055 16.3641 5.19598 15.3215 4.72028C14.2788 4.24459 13.146 3.99893 12 4Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnReset);
export default __webpack_public_path__ + "static/media/icn_reset.c35af1edd4745cf2c6be59f83dec5c65.svg";
export { ForwardRef as ReactComponent };